<template>
  <vx-card class="mt-base" title="4. Porosity">
    <p class="mb-5">
      Porosity refers to the hair’s ability to absorb moisture and hair products. While not as
      commonly discussed as hair type and structure, knowing how porous hair is can help you to
      decide the types of products to use.
    </p>
    <h4 class="mb-5">Take the Porosity Test: How Porous Is Your Hair?</h4>
    <p class="mb-5">
      A simple way to assess how porous your hair is to remove a single strand of hair from your
      head and place it into a bowl of water.
    </p>
    <ul class="default-list">
      <li>
        If the strand of hair sinks to the bottom, it means it has absorbed all the moisture;
        therefore, it has high porosity.
      </li>
      <li>
        If the strand of hair stays below the surface but still floats above the bottom of the bowl,
        it is well-balanced and medium porosity.
      </li>
      <li>
        If the strand of hair floats on the water’s surface, it does not absorb water easily;
        therefore, it has low porosity.
      </li>
    </ul>
    <h4 class="mb-5">Porosity: What Does This Mean For Hair Treatment?</h4>

    <p class="mb-5">
      Typically, hair with high porosity absorbs moisture too quickly. This is due to the cuticles
      being more open. Cuticles are the outermost layer that protects the hair strand. When damaged,
      the hair becomes dry and brittle as it can no longer hold in the moisture.
    </p>
    <p class="mb-5">
      When working with high porosity hair, it’s best to avoid harsh chemicals that dry out the hair
      even more. It’s also best to avoid heat styling the hair as this will dry it out more and
      cause more damage to the cuticles.
    </p>
    <p class="mb-5">
      Seek out treatments that will help moisturise and seal the cuticle to prevent further damage,
      e.g., nourishing hair masks, leave-in treatments, and oils.
    </p>
    <p class="mb-5">
      On the other hand, low porosity hair blocks water and moisture from being absorbed into the
      strands. The biggest concern for this hair type is the buildup of product residues. This is
      why it’s recommended that hair products are applied when the hair is still wet, to help ensure
      they are more evenly distributed and more easily absorbed.
    </p>

    <div v-for="(question, index) in questions" :key="index">
      <h5 class="mb-5 questionlabel">{{ question.question }}</h5>
      <div class="vx-row my-5">
        <div class="vx-col w-full mb-2" v-if="isEditable">
          <select
            class="default-select"
            v-model="answers['question' + index]"
            :aria-label="question.question"
          >
            <option v-for="answer in question.answers" :key="answer.val" :value="answer.val">
              {{ answer.answer }}
            </option>
          </select>
        </div>
        <div class="my-2 mx-5" v-else>
          <p
            class="my-2"
            v-for="answer in question.answers"
            :key="answer.val"
            v-if="answers['question' + index] != 0"
          >
            <span v-if="answers['question' + index] == answer.val">{{ answer.answer }}</span>
          </p>
          <p class="my-2" v-else>N/A</p>
        </div>
      </div>
    </div>

    <save-buttons
      :is-editable="isEditable"
      @save="save"
      :student-back="
        '/student/work-experience/' + this.$route.params.id + '/activities/identifying-hair-types'
      "
      :teacher-back="
        '/teacher/vje/experience/view/' +
        this.$route.params.id +
        '/activities/identifying-hair-types'
      "
    />
  </vx-card>
</template>

<script>
import computed from '@/views/WorkExperiences/components/activity_js/computed';
import inject from '@/views/WorkExperiences/components/activity_js/inject';

export default {
  data() {
    return {
      questions: {
        1: {
          question: 'My hair porosity is:',
          answers: [
            { val: 0, answer: 'Select your hair porosity' },
            { val: 1, answer: 'High' },
            { val: 2, answer: 'Medium' },
            { val: 3, answer: 'Low' },
          ],
        },
      },
      answers: {
        question1: 0,
      },
    };
  },
  methods: {
    save() {
      this.data = this.answers;
      this.saveActivity(this.$route.params.slug, this.data, -1);
    },
  },
  computed: computed,
  inject: inject,
  mounted() {
    if (this.data.question1) {
      this.answers = this.data;
    }
  },
};
</script>
